<template>
  <div>
    <div  class="d-flex w-100 justify-content-between mt-2">
      <div><Pagination size="small" class="mr-2 mb-1" :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/></div>
      <b-button-group class="mb-1">
        <slot name="list-buttons"></slot>
        <b-button size="sm" variant="danger" @click="$emit('close')">
          {{ $dt('label_set_activities.close_btn', 'Close history') }}
        </b-button>
      </b-button-group>
    </div>
    <b-list-group>
      <b-list-group-item v-for="item in items" :key="item.id"
        @click="activityClick(item)"  href="#" :active="selectedActivityId === item.id"
        :class="['flex-column align-items-start py-1 px-2 has-default-router-link min-row', { empty: !!item.empty }]">

        <b-spinner small v-if="item.empty && loading" type="grow" variant="primary"/>
        <div v-if="!item.empty" class="d-flex w-100 justify-content-between">
          <span>
            <!-- <small class="idcol mr-2">{{item.id}}:</small> -->
            <span>{{ momentf(item.created_at, 'DD.MM.YY') }}</span>
            <small class="mx-1">{{ momentf(item.created_at, 'HH:mm') }}</small>
            <span v-if="item.auth_method === 'access'"><i class="mx-1 fa fa-user "/></span>
            <span v-if="item.auth_method === 'api'"><i class="mx-1 fa fa-wrench "/></span>
            <small v-if="item.causer" class="mx-1">{{ item.causer.email }}</small>
          </span>
          <div class="flex-container options-center">
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import { mapState } from 'vuex';
import Services from '@/services/index';

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      page: 1,
      filters: {
        search: '',
        per_page: 5,
      },
      loading: false,
      list: {},
    };
  },
  props: {
    labelSetId: { type: Number, required: true },
    sampleId: { type: Number, required: true },
    selectedActivityId: { type: Number, default: null },
  },
  components: {
    Pagination
  },
  computed: {
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    validItems() { return this.list.data || []; },
    items() {
      const emptyItemCount = Math.max(0, this.filters.per_page - this.validItems.length);
      const emptyItems = [...Array(emptyItemCount)].map((_, idx) => ({ id: `empty${idx}`, empty: true }));
      return [...this.validItems, ...emptyItems] || [];
    },
    params() {
      return {
        ...this.filters,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
    ...mapState('Auth', ['activeProjectId']),
  },
  watch: {
    page: 'getData',
    'filters.search'() { this.page = 1; },
    filters: { deep: true, handler: 'getData' },
    activeProjectId() {
      if (this.activeProjectId) {
        this.getData();
      } else {
        this.list = { data: [] };
      }
    },
  },
  methods: {
    getData() {
      this.loading = true;
      this.list = { data: [] };
      Services.auditLogs.listLabelSetActivities({
        projectId: this.activeProjectId,
        sampleId: this.sampleId,
        labelSetId: this.labelSetId,

        ...this.params,
      })
        .then(({ data }) => {
          this.list = data;
          this.loading = false;
        }).catch((err) => {
          if (err.code !== 'ERR_CANCELED') {
            this.loading = false;
            console.log(err);
          }
        });
    },
    onPageChange(page) {
      this.page = page || this.page;
    },
    activityClick(item) {
      // console.log(item.properties.activities);
      // if (item.properties && item.properties.activities) {
      this.$emit('activityClick', item);
      // }
    },
  }
};
</script>

<style scoped lang="scss">
.has-default-router-link:hover .default-router-link {
  text-shadow: 0px 0px 2px $white, 0px 0px 4px $black;
}

.min-row {
  min-height: 2.22em;

  &.empty {
    background-color: $gray-200;
  }
}

.idcol {
  min-width: 30px;
  display: inline-block;
  text-align: right;
}
</style>
